import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To set up Slack notifications, you must:`}</p>
    <ol>
      <li parentName="ol">{`Create an incoming webhook in Slack.`}</li>
      <li parentName="ol">{`Provide that webhook's URL to GraphOS Studio.`}</li>
    </ol>
    <h4 {...{
      "id": "1-create-an-incoming-slack-hook"
    }}><a parentName="h4" {...{
        "href": "#1-create-an-incoming-slack-hook"
      }}>{`1. Create an incoming Slack hook`}</a></h4>
    <p>{`To create an incoming Slack hook:`}</p>
    <ol>
      <li parentName="ol">{`From the `}<a parentName="li" {...{
          "href": "https://slack.com/apps/A0F7XDUAZ-incoming-webhooks"
        }}>{`Incoming Hooks`}</a>{` page of the Slack App Directory, sign in and click `}<strong parentName="li">{`Add to Slack`}</strong>{`.`}</li>
      <li parentName="ol">{`Select the Slack channel that should receive notifications. Then, click `}<strong parentName="li">{`Add Incoming WebHooks integration`}</strong>{`.`}</li>
      <li parentName="ol">{`Copy the `}<strong parentName="li">{`Webhook URL`}</strong>{` to use in the next step. It should have a format like `}<inlineCode parentName="li">{`https://hooks.slack.com/services/...`}</inlineCode>{`.`}</li>
    </ol>
    <p>{`You can repeat this process to create webhook URLs for different Slack channels.`}</p>
    <h4 {...{
      "id": "2-provide-the-slack-hook-to-studio"
    }}><a parentName="h4" {...{
        "href": "#2-provide-the-slack-hook-to-studio"
      }}>{`2. Provide the Slack hook to Studio`}</a></h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In `}<a parentName="p" {...{
            "href": "https://studio.apollographql.com/?referrer=docs-content"
          }}>{`GraphOS Studio`}</a>{`, specify a name for this notification channel in the `}<strong parentName="p">{`Channel Name`}</strong>{` field.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`This name must be unique among your graph's notification channels.`}</li>
          <li parentName="ul">{`This name doesn't have to match the name of the Slack channel, but it's recommended for simplicity.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the `}<strong parentName="p">{`Slack Webhook URL`}</strong>{` field, paste the webhook URL you obtained in `}<a parentName="p" {...{
            "href": "#1-create-an-incoming-slack-hook"
          }}>{`Create an incoming Slack hook`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Next`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After you finish setup, check that your Slack channel gets a confirmation from Studio.`}</p>
      </li>
    </ol>
    <p>{`To configure multiple Slack channels, repeat this process. Use a different webhook URL for each channel.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      